import React from 'react'
import { Star, StarEmpty } from './SVG';


interface Props {
    rating: number
}

export default function Rating({ rating }: Props) {


    return (
        <div className='rating'>
            {[1, 2, 3, 4, 5].map((value) =>
                <React.Fragment key={value}>
                    {value <= rating ? Star : StarEmpty}
                </React.Fragment>)}
        </div>
    )
}
